import { Box, StyleProps } from "@chakra-ui/react";
import React from "react";
import { usePageContentContext } from "shared/components/layout/PageContentContext";
import { ScrollBottomPaddingHack } from "shared/components/layout/ScrollBottomPaddingHack";

const PageBody: React.FC<React.PropsWithChildren<StyleProps>> = ({
  children,
  ...props
}) => {
  const { isFullHeight } = usePageContentContext();
  return (
    <Box
      className="mb-page-body"
      flex={1}
      overflow="unset !important"
      minHeight={0}
      sx={
        isFullHeight
          ? {
              display: "flex",
              overflowY: "hidden",
              flexDirection: "column",
            }
          : undefined
      }
      {...props}
    >
      {children}
      <ScrollBottomPaddingHack />
    </Box>
  );
};

export default PageBody;
